var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/MobileBanner/MobileBanner.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Box } from '@wds/box';
import { Sheet } from '@wds/sheet';
import { Button } from '@wds/button';
import { Grid } from '@wds/grid';
import { Typography } from '@wds/typography';
import { IconLogoGoldie, IconStar, IconStarFilled } from '@wds/icons';
import { getClientEnvironmentDetails } from '@sm/utils';
import useStyles from './useStyles';
import { WebAssetsThemeWrapper } from '../../theme';
var MobileBanner = function MobileBanner(props) {
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(MobileBannerContent, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  })));
};
var MobileBannerContent = function MobileBannerContent(_ref) {
  var _ref$iosRatingText = _ref.iosRatingText,
    iosRatingText = _ref$iosRatingText === void 0 ? 'SurveyMonkey on iOS' : _ref$iosRatingText,
    _ref$iosRating = _ref.iosRating,
    iosRating = _ref$iosRating === void 0 ? 4 : _ref$iosRating,
    _ref$androidRatingTex = _ref.androidRatingText,
    androidRatingText = _ref$androidRatingTex === void 0 ? 'SurveyMonkey on Android' : _ref$androidRatingTex,
    _ref$androidRating = _ref.androidRating,
    androidRating = _ref$androidRating === void 0 ? 4 : _ref$androidRating,
    _ref$deepLinkText = _ref.deepLinkText,
    deepLinkText = _ref$deepLinkText === void 0 ? 'Open in App' : _ref$deepLinkText,
    _ref$installText = _ref.installText,
    installText = _ref$installText === void 0 ? 'Install' : _ref$installText,
    _ref$deepLinkData = _ref.deepLinkData,
    deepLinkData = _ref$deepLinkData === void 0 ? {} : _ref$deepLinkData,
    downloadLink = _ref.downloadLink,
    _ref$isUserEligible = _ref.isUserEligible,
    isUserEligible = _ref$isUserEligible === void 0 ? false : _ref$isUserEligible;
  var _useStyles = useStyles(),
    logoAlign = _useStyles.logoAlign;
  var environmentDetails = getClientEnvironmentDetails();
  var getCookie = function getCookie(name) {
    var match = environmentDetails.isNode ? null : document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]+)")));
    if (match) {
      return match[2];
    }
    return null;
  };
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showBanner = _useState2[0],
    setShowBanner = _useState2[1];
  var _useState3 = useState(new Date().getTime()),
    _useState4 = _slicedToArray(_useState3, 1),
    sessionTime = _useState4[0];
  var _useState5 = useState(function () {
      if (isUserEligible || environmentDetails.isMobile && !environmentDetails.isNode && getCookie('sb-closed') !== 'true' && getCookie('sb-installed') !== 'true') {
        return true;
      }
      return false;
    }),
    _useState6 = _slicedToArray(_useState5, 1),
    isUserEligibleState = _useState6[0];
  var setCookie = function setCookie(name) {
    // Set close cookie
    var dateRightNow = new Date();
    var expiryDate = new Date(dateRightNow.getTime() + 15 * 24 * 60 * 60 * 1000);
    var cookieValue = "".concat(encodeURI('true'), "; expires=").concat(expiryDate.toUTCString());
    document.cookie = "".concat(name, "=").concat(cookieValue, "; path=/;");
  };
  var getDownloadLink = function getDownloadLink() {
    if (!downloadLink) {
      // eslint-disable-next-line no-throw-literal
      throw 'no download link';
    }
    var newDownloadLink = "".concat(downloadLink, "?path=").concat(encodeURIComponent(window.location.pathname));
    if (deepLinkData && Object.keys(deepLinkData).length !== 0) {
      newDownloadLink = "".concat(downloadLink, "&").concat(Object.keys(deepLinkData).map(function (k) {
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(deepLinkData[k]));
      }).join('&'));
    }
    newDownloadLink = "".concat(downloadLink, "&session=").concat(sessionTime);
    return newDownloadLink;
  };
  var handleOnClose = function handleOnClose() {
    setCookie('sb-closed');
    setShowBanner(false);
  };
  var handleInstallClick = function handleInstallClick() {
    setCookie('sb-installed');
    setShowBanner(false);
    window.location.assign(getDownloadLink());
  };
  var handleOpenClick = function handleOpenClick() {
    setCookie('sb-closed');
    setShowBanner(false);
    window.location.assign(getDownloadLink());
  };
  var getRatingStars = function getRatingStars() {
    var starRating = environmentDetails.isAndroid ? androidRating : iosRating;
    var starRatingNodes = [];
    for (var starCount = 0; starCount < starRating && starCount < 5; starCount += 1) {
      starRatingNodes.push( /*#__PURE__*/React.createElement(IconStarFilled, {
        title: "Star Filled",
        color: "upgrade",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114,
          columnNumber: 9
        }
      }));
    }
    for (var _starCount = starRating; _starCount < 5; _starCount += 1) {
      starRatingNodes.push( /*#__PURE__*/React.createElement(IconStar, {
        title: "Empty Star",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118,
          columnNumber: 28
        }
      }));
    }
    return starRatingNodes;
  };
  var getRatingText = function getRatingText() {
    var starRatingText = environmentDetails.isAndroid ? androidRatingText : iosRatingText;
    return /*#__PURE__*/React.createElement(Typography, {
      component: "div",
      variant: "cardTitle",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 128,
        columnNumber: 7
      }
    }, starRatingText);
  };
  return isUserEligibleState ? /*#__PURE__*/React.createElement(Sheet, {
    show: showBanner,
    blocking: false,
    placement: "bottom",
    onClose: handleOnClose,
    showCloseButton: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Box, {
    p: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    xs: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: logoAlign,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(IconLogoGoldie, {
    title: "SurveyMonkey Logo",
    size: "xl",
    color: "primary",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(Grid.Item, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    noGutters: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 154,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexJustify: "center",
    flexAlign: "flex-start",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 17
    }
  }, getRatingText(), "\xA0", /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 19
    }
  }, getRatingStars()))), /*#__PURE__*/React.createElement(Grid.Item, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexJustify: "center",
    flexAlign: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Button, {
    label: installText,
    onClick: handleInstallClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 19
    }
  }, installText), /*#__PURE__*/React.createElement(Button, {
    label: deepLinkText,
    color: "alt",
    onClick: handleOpenClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 19
    }
  }, deepLinkText)))))))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default MobileBanner;
//# sourceMappingURL=MobileBanner.js.map